/**
 * KTUI - Free & Open-Source Tailwind UI Components by Keenthemes
 * Copyright 2025 by Keenthemes Inc
 */

export { KTCollapse } from './collapse';
export type { KTCollapseConfigInterface, KTCollapseInterface } from './types';
